/* eslint-disable */
// FIXME: enable eslint?
// handles only the myhome-related registration state, all the rest is shared
// with orders.js
import Vue from "vue";
import ModalAlert from "@/components/patterns/ModalAlert"; // eslint-disable-line import/no-extraneous-dependencies
import userLogout from "~/helpers/userLogout"; // eslint-disable-line import/no-extraneous-dependencies
import Registration from "../../clients/registrations"; // eslint-disable-line import/no-extraneous-dependencies

const state = {
  myHomeRegistrations: {},
  registrationsLoaded: false,
  isRegistrationLoaded: false,
  deeplinkedRegistration: {},
};

const getters = {
  filterRegistrations: (moduleState, getters, rootState) => (
    ticketFilter,
    includeBundleChildren,
    deeplinkedRegistration
  ) => {
    let filtered = [];
    for (let item in moduleState.myHomeRegistrations) {
      const registration = moduleState.myHomeRegistrations[item];
      if (registration.bundle_parent && !includeBundleChildren) {
        continue;
      }
      if (ticketFilter === "festival" && registration.linked_event.categories.map(item => item.id).indexOf(134) > -1) {
        filtered.push(registration);
      }
      if (
        ticketFilter === "future" &&
        (registration.to_be_completed || registration.is_active) &&
        (registration.bundle_children.length || !registration.past)
      ) {
        filtered.push(registration);
      } else if (
        ticketFilter === "past" &&
        registration.is_active &&
        (registration.is_event_attended || registration.is_processing_attendances) &&
        (registration.bundle_children.length || registration.past)
      ) {
        filtered.push(registration);
      } else if (ticketFilter === "waitingList" && registration.state === rootState.config.states.waiting_list) {
        filtered.push(registration);
      } else if (registration.id === deeplinkedRegistration) {
        filtered.push(registration);
      }
    }
    return filtered;
  },
  filteredRegistrations: (moduleState, getters, rootState) => includeBundleChildren => {
    return getters.filterRegistrations(
      rootState.myhome.ticketFilter,
      includeBundleChildren,
      moduleState.deeplinkedRegistration
    );
  },
  notAttendedRegistrations: (moduleState, getters, rootState) => () => {
    let filtered = [];
    for (let item in moduleState.myHomeRegistrations) {
      const registration = moduleState.myHomeRegistrations[item];
      if (
        rootState.myhome.ticketFilter === "notAttended" &&
        (registration.is_unattended || (registration.state === "expired" && !registration.past))
      ) {
        filtered.push(registration);
      }
    }
    return filtered;
  },
  preRegistrations: (moduleState, getters, rootState) => () => {
    let filtered = [];
    for (let item in moduleState.myHomeRegistrations) {
      const registration = moduleState.myHomeRegistrations[item];
      if (
        rootState.myhome.ticketFilter === "waitingList" &&
        registration.state === rootState.config.states.pre_registration
      ) {
        filtered.push(registration);
      }
    }
    return filtered;
  },
  eventTypes: () => registrations => {
    let types = {};
    for (let registration of registrations) {
      types[registration.linked_event.type] = registration.linked_event.type_label;
    }
    return types;
  },
  myHomeRegistrations: moduleState => moduleState.myHomeRegistrations,
  registrationsLoaded: moduleState => moduleState.registrationsLoaded,
  registrationIsLoaded: moduleState => moduleState.isRegistrationLoaded,
};

const actions = {
  async fetchRegistrations({ commit, rootState }, registrationId) {
    commit("resetRegistrationsLoaded", false);
    try {
      commit("setDeeplinkedRegistration", registrationId);
      const registrations = await Registration.getRegistrations(rootState.config);
      commit("setMyHomeRegistrations", registrations.results);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async fetchRegistration({ commit, rootState, dispatch }, { registrationId, force }) {
    if (
      rootState.orders.registrations.length !== 1 ||
      rootState.orders.registrations[0].id !== registrationId ||
      force
    ) {
      try {
        const registration = await Registration.getRegistration(rootState.config, registrationId);
        // this is needed to build the same state as during the registration process, without the sliding window
        // behavior
        commit("setRegistrations", [registration]);
        commit("setActiveRegistrationIndex", 0);
        commit("setEmptySessions");
        commit("setMapSelectedLabs");
        commit("updateRegistrationLoading", true);
        dispatch("setSurvey");
      } catch (e) {
        if (e.response && e.response.status === 401) {
          userLogout();
        }
        ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
      }
    }
  },
  async cancelRegistration({ commit, rootState }, registrationId) {
    try {
      const registration = await Registration.cancelRegistration(rootState.config, registrationId);
      commit("replaceMyHomeRegistration", registration);
      return registration;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
};

const mutations = {
  setMyHomeRegistrations: (oldState, registrations) => {
    for (let registration of registrations) {
      oldState.myHomeRegistrations[registration.id] = registration;
    }
    oldState.registrationsLoaded = true;
  },
  setDeeplinkedRegistration: (oldState, registration) => {
    oldState.deeplinkedRegistration = registration;
  },
  replaceMyHomeRegistration: (oldState, registration) => {
    Vue.set(oldState.myHomeRegistrations, registration.id, registration);
  },
  updateRegistrationLoading: (oldState, payload) => {
    oldState.isRegistrationLoaded = payload;
  },
  resetRegistrationsLoaded: (oldState, payload) => {
    oldState.registrationsLoaded = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
